import { GraphicalDataSourceBase } from "abweb/dto/generated/gds/GraphicalDataSourceBase";
export class GraphicalDataSource extends GraphicalDataSourceBase {
  static createGraphicalDataSource(id, rootNode, dataSources, focusedNodeId, clientRequestContext = null, argumentValues = null) {
    const retVal = new GraphicalDataSource();
    retVal.initGraphicalDataSource(argumentValues, clientRequestContext, id, dataSources, focusedNodeId, [], rootNode, /*templateMap*/null);
    return retVal;
  }
  constructor() {
    super();
  }
  initGraphicalDataSource(argumentValues, clientRequestContext, id, dataSources, focusedNodeId, messages, rootNode, templateMap) {
    super.initGraphicalDataSource(argumentValues, clientRequestContext, id, dataSources, focusedNodeId, messages, rootNode, templateMap);
    this.setUpNodes(this.rootNode, null);
  }
  setUpNodes(node, parentNode) {
    if (node == null) {
      return;
    }
    node._parentNode = parentNode;
    if (node.nodes == null) {
      return;
    }
    for (let childNode of node.nodes) {
      this.setUpNodes(childNode, node);
    }
  }
  get width() {
    if (this.rootNode) {
      return this.rootNode.width;
    }
    return 0;
  }
  get height() {
    if (this.rootNode) {
      return this.rootNode.height;
    }
    return 0;
  }
  get nodes() {
    if (this.rootNode) {
      return this.rootNode.nodes;
    }
    return [];
  }
  get edges() {
    if (this.rootNode) {
      return this.rootNode.edges; // TODO Transitional cast
    }
    return [];
  }

  /**
   * Returns a map of internal datasources
   */
  get dataSourcesMap() {
    // TODO This could be cached as a static list
    let dsm = new Map();
    for (const ds of this.dataSources || []) {
      if (ds && ds.id) {
        dsm.set(ds.id, ds);
      }
    }
    return dsm;
  }

  /**
   * Returns flattened list of nodes.
   * @param startNode Node to start at.
   * If null, we start at the root. Note that the rootNode is not included in the list.
   * @returns {any}
   */
  getFlattenedNodeList(startNode = null) {
    let ret = [];
    if (startNode == null || startNode === this.rootNode) {
      if (this.nodes == null) {
        return [];
      }
      for (let node of this.nodes) {
        this.getFlattenedNodeListHelper(node, ret);
      }
    } else {
      this.getFlattenedNodeListHelper(startNode, ret);
    }
    return ret;
  }
  getFlattenedNodeListHelper(node, list) {
    list.push(node);
    if (node.nodes == null) {
      return;
    }
    for (let childNode of node.nodes) {
      if (childNode) {
        this.getFlattenedNodeListHelper(childNode, list);
      }
    }
  }

  /**
   * Returns flattened list of edges.
   * @param startNode Node to start at.
   * If null, we start at the root.
   * @returns {any}
   */
  getFlattenedEdgeList(startNode = null) {
    let ret = [];
    startNode = startNode || this.rootNode;
    if (startNode == null) {
      return [];
    } else {
      this.getFlattenedEdgeListHelper(startNode, ret);
    }
    return ret;
  }
  getFlattenedEdgeListHelper(node, list) {
    if (node.edges) {
      for (let edge of node.edges) {
        if (edge) {
          list.push(edge);
        }
      }
    }
    if (node.nodes) {
      for (let childNode of node.nodes) {
        if (childNode) {
          this.getFlattenedEdgeListHelper(childNode, list);
        }
      }
    }
  }
  findDataSourceByName(id) {
    if (id == null || this.dataSources == null) {
      return null;
    }
    for (let ds of this.dataSources) {
      if (ds && ds.id === id) {
        return ds;
      }
    }
    return null;
  }

  /**
   * Gets the DataSourceRecord associated with the graphicalObject.
   * Will set the cached value if not already found.
   * @param graphicalObject Node or edge.
   * @returns {any} DataSourceRecord or null if it cannot be found.
   */
  getDataSourceRecord(graphicalObject) {
    if (graphicalObject._record) {
      return graphicalObject._record;
    }
    if (graphicalObject.dataSourceRecordReference == null || !graphicalObject.dataSourceRecordReference.isValid) {
      return null;
    }
    let ds = this.findDataSourceByName(graphicalObject.dataSourceRecordReference.dataSourceId);
    if (ds == null) {
      return null;
    }
    let rec = ds.findRecordById(graphicalObject.dataSourceRecordReference.recordId);
    if (rec == null) {
      return null;
    }

    // set cached value for future use
    graphicalObject._record = rec;
    return rec;
  }

  /**
   * Finds a node by its id value.
   * @param id id to find
   * @param startNode Start node. If null, we start the search at the rootNode.
   * @returns Matching GraphicalDataSourceNode or null if not found.
   */
  findNodeById(id, startNode = null) {
    if (startNode == null) {
      startNode = this.rootNode;
    }
    if (startNode == null) {
      return null;
    }
    if (startNode.id === id) {
      return startNode;
    }

    // Check descendants
    if (startNode.nodes == null) {
      return null;
    }
    for (let childNode of startNode.nodes) {
      let test = this.findNodeById(id, childNode);
      if (test) {
        return test;
      }
    }
    return null;
  }
  findEdgeById(id, startNode = null) {
    let edgeList = this.getFlattenedEdgeList(startNode);
    for (let edge of edgeList) {
      if (edge.id === id) {
        return edge;
      }
    }
    return null;
  }
}
//# sourceMappingURL=GraphicalDataSource.js.map
